import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';

const field = {
  borderBottom: '1px solid #333',
  outline: 'none',
  width: '100%',
  background: 'transparent',
  fontSize: 15,
  padding: '2px 4px',
  fontFamily: 'inherit',
  color: '#222',
};

const label = {
  fontWeight: 'normal',
  fontSize: 15,
  color: '#222',
  whiteSpace: 'nowrap',
};

const section = {
  marginBottom: 8,
  display: 'flex',
  alignItems: 'flex-end',
  gap: 6,
};

export default function Enrollment() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const [form, setForm] = useState({
    nom: '', prenom: '', nom_jeune_fille: '',
    date_naissance: '', lieu_naissance: '',
    adresse1: '', adresse2: '',
    telephone_domicile: '', telephone: '',
    email: '',
    baptise: '', date_bapteme: '', eglise_bapteme: '',
    confirme: '', date_confirmation: '', eglise_confirmation: '',
    opposition_donnees: false,
    ville_signature: '', date_signature: '',
  });

  const set = (name, value) => setForm(prev => ({ ...prev, [name]: value }));
  const handleChange = e => set(e.target.name, e.target.type === 'checkbox' ? e.target.checked : e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.nom || !form.prenom || !form.email || !form.date_naissance || !form.lieu_naissance) {
      setError('Veuillez remplir tous les champs obligatoires (*).');
      return;
    }
    try {
      setSaving(true);
      await apiService.submitEnrollment({
        nom: form.nom,
        prenom: form.prenom,
        nom_jeune_fille: form.nom_jeune_fille,
        email: form.email,
        telephone: form.telephone,
        telephone_domicile: form.telephone_domicile,
        date_naissance: form.date_naissance,
        lieu_naissance: form.lieu_naissance,
        adresse_postale: [form.adresse1, form.adresse2].filter(Boolean).join(', '),
        baptise: form.baptise === 'oui',
        date_bapteme: form.date_bapteme || undefined,
        eglise_bapteme: form.eglise_bapteme || undefined,
        confirme: form.confirme === 'oui',
        date_confirmation: form.date_confirmation || undefined,
        eglise_confirmation: form.eglise_confirmation || undefined,
        opposition_donnees: form.opposition_donnees,
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Erreur lors de la soumission');
    } finally {
      setSaving(false);
    }
  };

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f2f5f2' }}>
        <div style={{ background: '#fff', padding: 48, borderRadius: 10, maxWidth: 540, textAlign: 'center', boxShadow: '0 2px 16px rgba(0,0,0,0.09)' }}>
          <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
          <h2 style={{ color: '#1F7040', fontSize: 22, fontWeight: 700, marginBottom: 12 }}>Demande envoyée !</h2>
          <p style={{ color: '#444', lineHeight: 1.7, marginBottom: 24 }}>
            Votre demande d'adhésion a bien été transmise au Conseil d'Église.<br />
            Vous recevrez un email de confirmation dès validation de votre inscription.
          </p>
          <button onClick={() => navigate('/')} style={{ background: '#1F7040', color: '#fff', border: 'none', borderRadius: 7, padding: '10px 28px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f2f5f2', padding: '32px 16px', fontFamily: 'Georgia, Times New Roman, serif' }}>
      <div style={{ maxWidth: 720, margin: '0 auto 12px' }}>
        <button type="button" onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#1F7040', fontSize: 14, fontWeight: 600, cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
          ← Retour à l'accueil
        </button>
      </div>
      <form onSubmit={handleSubmit} style={{ maxWidth: 720, margin: '0 auto', background: '#fff', padding: '36px 44px', boxShadow: '0 2px 16px rgba(0,0,0,0.10)', borderRadius: 4 }}>

        {/* EN-TÊTE */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 24, borderBottom: '2px solid #1F7040', paddingBottom: 20 }}>
          <img src="/logo-eecf.png" alt="EECF" style={{ width: 72, height: 72, objectFit: 'contain' }} />
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#444', lineHeight: 1.5 }}>
              Mwemba ma Myango ma Bwam ma Kamerun o Frensi<br />
              Église Évangélique du Cameroun en France<br />
              Evangelical Church of Cameroon in France
            </div>
            <div style={{ fontSize: 11, color: '#666', marginTop: 6 }}>
              38 rue Camille Desmoulins 94230 Cachan &nbsp;•&nbsp; +33 (0)6 63 59 70 04 &nbsp;•&nbsp; accueil@eecf-paris.fr
            </div>
          </div>
        </div>

        {/* TITRE */}
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <h1 style={{ fontSize: 17, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, margin: 0 }}>
            Demande d'inscription ou de réinscription<br />sur la liste des membres
          </h1>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#1F7040', marginTop: 6 }}>
            Année {new Date().getFullYear()}
          </div>
        </div>

        {/* RAPPEL ARTICLE 4 */}
        <div style={{ border: '1px solid #ccc', borderRadius: 4, padding: '12px 16px', marginBottom: 20, fontSize: 12.5, lineHeight: 1.7, color: '#333', background: '#fafafa' }}>
          <div style={{ fontWeight: 700, textDecoration: 'underline', marginBottom: 6 }}>
            Rappel des Statuts de l'Association Cultuelle de l'Eglise Evangélique du Cameroun en France
          </div>
          <p style={{ margin: 0 }}>
            <strong>Article 4.</strong> L'Association Cultuelle de l'Église Évangélique du Cameroun en France accueille comme
            Membres Actifs ceux qui reconnaissent que "Jésus-Christ est le Seigneur", et qui, sur leur demande et sauf
            refus motivé du Conseil d'Église, ont été inscrits sur la liste des membres.
          </p>
          <p style={{ margin: '6px 0 0' }}>
            <strong>N.B. :</strong> La liste des membres de la Paroisse, qui comprend leurs noms, prénoms, date de naissance,
            adresse et la date d'inscription sur la liste, est tenue à jour par le Conseil d'Église qui la révise tous les ans
            au cours du dernier trimestre de l'année.
          </p>
        </div>

        <div style={{ borderTop: '1px dashed #aaa', marginBottom: 18 }} />
        <div style={{ fontSize: 14, marginBottom: 16, color: '#444' }}>Je soussigné(e),</div>

        {/* CHAMPS IDENTITÉ */}
        <div style={section}>
          <span style={label}>Nom(s) <span style={{ color: 'red' }}>*</span></span>
          <input name="nom" value={form.nom} onChange={handleChange} required style={{ ...field, flex: 1 }} />
        </div>

        <div style={section}>
          <span style={label}>Prénom(s) <span style={{ color: 'red' }}>*</span></span>
          <input name="prenom" value={form.prenom} onChange={handleChange} required style={{ ...field, flex: 1 }} />
        </div>

        <div style={section}>
          <span style={label}>Nom de Jeune-Fille</span>
          <input name="nom_jeune_fille" value={form.nom_jeune_fille} onChange={handleChange} style={{ ...field, flex: 1 }} />
        </div>

        <div style={{ ...section, gap: 16 }}>
          <span style={label}>Né(e) le <span style={{ color: 'red' }}>*</span></span>
          <input type="date" name="date_naissance" value={form.date_naissance} onChange={handleChange} required style={{ ...field, width: 160 }} />
          <span style={label}>à <span style={{ color: 'red' }}>*</span></span>
          <input name="lieu_naissance" value={form.lieu_naissance} onChange={handleChange} placeholder="Ville, Pays" required style={{ ...field, flex: 1 }} />
        </div>

        <div style={section}>
          <span style={label}>Adresse</span>
          <input name="adresse1" value={form.adresse1} onChange={handleChange} placeholder="N°, rue..." style={{ ...field, flex: 1 }} />
        </div>
        <div style={section}>
          <input name="adresse2" value={form.adresse2} onChange={handleChange} placeholder="Code postal, Ville, Pays" style={{ ...field, flex: 1, marginLeft: 80 }} />
        </div>

        <div style={{ ...section, gap: 16 }}>
          <span style={label}>Tél. Domicile</span>
          <input name="telephone_domicile" value={form.telephone_domicile} onChange={handleChange} placeholder="01 23 45 67 89" style={{ ...field, width: 180 }} />
          <span style={label}>Portable</span>
          <input name="telephone" value={form.telephone} onChange={handleChange} placeholder="06 12 34 56 78" style={{ ...field, flex: 1 }} />
        </div>

        <div style={section}>
          <span style={label}>E-mail <span style={{ color: 'red' }}>*</span></span>
          <input type="email" name="email" value={form.email} onChange={handleChange} required style={{ ...field, flex: 1 }} />
        </div>

        {/* BAPTÊME */}
        <div style={{ marginTop: 20, marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
            <span style={label}>Baptisé(e) :</span>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 15 }}>
              <input type="radio" name="baptise" value="oui" checked={form.baptise === 'oui'} onChange={handleChange} /> OUI
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 15 }}>
              <input type="radio" name="baptise" value="non" checked={form.baptise === 'non'} onChange={handleChange} /> NON
            </label>
          </div>
          {form.baptise === 'oui' && (
            <div style={{ ...section, marginTop: 8, marginLeft: 20, gap: 12, flexWrap: 'wrap' }}>
              <span style={label}>Si oui, Date :</span>
              <input type="date" name="date_bapteme" value={form.date_bapteme} onChange={handleChange} style={{ ...field, width: 160 }} />
              <span style={label}>Église :</span>
              <input name="eglise_bapteme" value={form.eglise_bapteme} onChange={handleChange} placeholder="Nom de l'église" style={{ ...field, flex: 1, minWidth: 160 }} />
            </div>
          )}
        </div>

        {/* CONFIRMATION */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
            <span style={label}>Confirmé(e) :</span>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 15 }}>
              <input type="radio" name="confirme" value="oui" checked={form.confirme === 'oui'} onChange={handleChange} /> OUI
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 15 }}>
              <input type="radio" name="confirme" value="non" checked={form.confirme === 'non'} onChange={handleChange} /> NON
            </label>
          </div>
          {form.confirme === 'oui' && (
            <div style={{ ...section, marginTop: 8, marginLeft: 20, gap: 12, flexWrap: 'wrap' }}>
              <span style={label}>Si oui, Date :</span>
              <input type="date" name="date_confirmation" value={form.date_confirmation} onChange={handleChange} style={{ ...field, width: 160 }} />
              <span style={label}>Église :</span>
              <input name="eglise_confirmation" value={form.eglise_confirmation} onChange={handleChange} placeholder="Nom de l'église" style={{ ...field, flex: 1, minWidth: 160 }} />
            </div>
          )}
        </div>

        {/* DÉCLARATION */}
        <div style={{ borderTop: '1px dashed #aaa', paddingTop: 16, marginBottom: 16, fontSize: 13.5, lineHeight: 1.8, color: '#333', fontStyle: 'italic' }}>
          Ayant pris connaissance de l'article 4 des Statuts de l'Association Cultuelle de l'Eglise Évangélique
          du Cameroun en France et reconnaissant que <strong style={{ fontStyle: 'normal' }}>"Jésus, le Christ est le Seigneur"</strong>,
          demande mon inscription comme membre de cette Association.
        </div>

        {/* SIGNATURE */}
        <div style={{ ...section, gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
          <span style={label}>À</span>
          <input name="ville_signature" value={form.ville_signature} onChange={handleChange} placeholder="Ville" style={{ ...field, width: 200 }} />
          <span style={label}>Le</span>
          <input type="date" name="date_signature" value={form.date_signature} onChange={handleChange} style={{ ...field, width: 180 }} />
        </div>

        <div style={{ marginBottom: 24, fontSize: 13, color: '#555', lineHeight: 1.6 }}>
          Les renseignements demandés ci-dessus sont nécessaires pour l'inscription comme membre, et uniquement destinés à l'association.
          Chaque membre dispose en tout temps d'un droit d'accès et de rectification des informations le concernant
          (loi n°78-17 du 6 janvier 1978 modifiée).
        </div>

        {/* RGPD */}
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, color: '#444', marginBottom: 24, cursor: 'pointer', lineHeight: 1.6 }}>
          <input type="checkbox" name="opposition_donnees" checked={form.opposition_donnees} onChange={handleChange} style={{ marginTop: 3, flexShrink: 0 }} />
          Je m'oppose à ce que les données me concernant soient utilisées par d'autres que les responsables de l'Association
          Cultuelle et notamment à des fins de prospection.
        </label>

        {/* ERREUR */}
        {error && (
          <div style={{ background: '#fff5f5', border: '1px solid #fc8181', color: '#c53030', borderRadius: 6, padding: '10px 14px', marginBottom: 16, fontSize: 14 }}>
            {error}
          </div>
        )}

        {/* BOUTON */}
        <button
          type="submit"
          disabled={saving}
          style={{
            width: '100%', background: saving ? '#aaa' : '#1F7040', color: '#fff',
            border: 'none', borderRadius: 6, padding: '13px 0', fontSize: 16,
            fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer', letterSpacing: 0.5,
          }}
        >
          {saving ? 'Envoi en cours...' : 'Soumettre ma demande d\'adhésion'}
        </button>

        <div style={{ textAlign: 'center', marginTop: 24, paddingTop: 16, borderTop: '1px solid #eee', fontSize: 12, color: '#888', fontWeight: 700, letterSpacing: 0.5 }}>
          CE DOCUMENT CONCERNE TOUS LES MEMBRES, ANCIENS ET NOUVEAUX ARRIVANTS.<br />
          IL DOIT IMPÉRATIVEMENT ÊTRE RETOURNÉ AU CONSEIL D'ÉGLISE POUR ÊTRE VALABLE.
        </div>

        <div style={{ textAlign: 'center', marginTop: 12, fontSize: 12, color: '#666' }}>
          📍 38 rue Camille Desmoulins 94230 Cachan &nbsp;•&nbsp;
          📞 +33 (0)6 63 59 70 04 &nbsp;•&nbsp;
          ✉️ accueil@eecf-paris.fr &nbsp;•&nbsp;
          🌐 www.eecf-paris.fr
        </div>
      </form>
    </div>
  );
}
